export const TELEGRAM_MINI_APP_QUERY_PARAM: string = 'lentaTgKey';
export const TELEGRAM_MINI_APP_QUERY_VALUE: string = 'tma';
export const OKEY_APP_STOREFRONT_LABEL: string = 'okeywebview';
